import React, { memo, useEffect, useState } from 'react';
import { StepContainer } from '../Styles';
import { afterApprovedStatus } from '../../../../utils/constants/statusMonitoring';

const stepCoordinates = (stepNumber) => {
  let coordinates = { x1: 0, y1: 0, x2: 0, y2: 0 };
  switch (stepNumber) {
    case 1:
      coordinates = { x1: 10, y1: 30, x2: 18.5, y2: 30 };
      break;
    case 2:
      coordinates = { x1: 18, y1: 30, x2: 18, y2: 21.5 };
      break;
    case 3:
      coordinates = { x1: 18, y1: 22, x2: 26.5, y2: 22 };
      break;
    case 4:
      coordinates = { x1: 26, y1: 22, x2: 26, y2: 13.5 };
      break;
    case 5:
      coordinates = { x1: 26, y1: 14, x2: 34.5, y2: 14 };
      break;
    case 6:
      coordinates = { x1: 34, y1: 14, x2: 34, y2: 5.5 };
      break;
    case 7:
      coordinates = { x1: 34, y1: 6, x2: 42, y2: 6 };
      break;
    default:
      coordinates = { x1: 0, y1: 0, x2: 0, y2: 0 };
  }
  return coordinates;
}

const SVG_LINES = Array(7).fill(8);

const getAnimateSteps = (level) => {
  // TOTAL 7 steps
  switch (level) {
    case 0:
      return [];
    case 1:
      return Array(1).fill(10);
    case 2:
      return Array(3).fill(10);
    case 3:
      return Array(5).fill(10);
    case 4:
      return Array(7).fill(10);
    default:
      return [];
  }
}

const getDisplayLevels = (level, status) => {
  const lowerCaseStatus = status.toLowerCase();
    return Array(level).fill(0).map((e, index) => {
      if (index < level - 1) {
        return { level: index + 1, status: 'completed' };
      } else if (index === level - 1) {
        return { level: index + 1, status: lowerCaseStatus.startsWith('approved')
          ? 'completed'
          : lowerCaseStatus.startsWith('reject')
            ? 'failed'
            : 'pending'
        };
      }
    });
}

const getImage = (status) => {
    switch (status) {
      case 'completed':
        return 'blueTick.svg';
      case 'pending':
        return 'pending.svg';
      case 'failed':
        return 'cross.svg';
      default:
        return null;
    }
}

const approveRejectStatus= [
  'waiting_for_approval_level_1',
  'waiting_for_approval_level_2',
  'waiting_for_approval_level_3',
  'waiting_for_approval_level_4',
  'reject_by_level_1',
  'reject_by_level_2',
  'reject_by_level_3',
  'reject_by_level_4',
  'approved_by_level_1',
  'approved_by_level_2',
  'approved_by_level_3',
  'approved_by_level_4',
]

const Steps = props => {
  const { status, activeItem={}, steps = [], size = 30, strokeWidth = 4, primaryColor = '#a123a3' } = props;
  const [animateSteps, setAnimateSteps] = useState([]);
  const [displayLevels, setDisplayLevels] = useState([]);

  useEffect(() => {
    try {
      let statusSplit = status?.split?.("_");
      let level = statusSplit[statusSplit.length - 1];
      level = parseInt(level);
      if(approveRejectStatus.includes(status)) {
        setAnimateSteps(getAnimateSteps(level));
        setDisplayLevels(getDisplayLevels(level, status));
      }else if(afterApprovedStatus.includes(status)){
        let approverLevel = parseInt(activeItem?.approver);
        setAnimateSteps(getAnimateSteps(approverLevel));
        setDisplayLevels(getDisplayLevels(approverLevel, 'approved'));
      }
    } catch (err) {
      console.log("Error in status split :: ", status);
    }
  }, [status]);

  return (
    <StepContainer>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="100%"
          height="100%"
          viewBox="0 0 42 32"
          className="steps"
        >
        <g clipRule="nonzero">
          {SVG_LINES.map((e, index) => {
            const coordinates = stepCoordinates(index + 1);
            return (
              <line x1={coordinates.x1} y1={coordinates.y1} x2={coordinates.x2} y2={coordinates.y2} style={{ strokeWidth: 1 }} />
            )
          })}
          {displayLevels.map((e, index) => {
            const coordinates = { x: 5 + (8 * index), y: 32 - 5 - (8 * index) };
            return (
              <>
                <image x={coordinates.x - 5} y={coordinates.y - 3} width={4} height={4} href={getImage(e.status)} />
                <text x={coordinates.x} y={coordinates.y} className="animate"> {`Level ${index + 1}`} </text>
              </>
            );
          })}
          {animateSteps.map((e, index) => {
            const coordinates = stepCoordinates(index + 1);
            return (
              <line x1={coordinates.x1} y1={coordinates.y1} x2={coordinates.x2} y2={coordinates.y2} style={{ strokeWidth: 1 }} className={`animate ${index !== 0 && index % 2 === 0 && 'delay'}`} />
            )
          })}
        </g>
        </svg>
    </StepContainer>
  )
};

export default memo(Steps);
